import { Outlet } from "react-router-dom";

const BootcampsRootLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default BootcampsRootLayout;
